import {
  ApplicationConfig,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withInMemoryScrolling, withViewTransitions } from '@angular/router';

import { routes } from './app.routes';
import { appViewTransitionOptions } from './app.transitions';
import { provideHttpClient, withFetch, withInterceptors, withXsrfConfiguration } from '@angular/common/http';
import { httpInterceptor } from './core/providers/interceptors/http.interceptor';
import { registerLocaleData } from '@angular/common';
import fr from '@angular/common/locales/fr';
import { providePrimeNG } from 'primeng/config';
import { ootdPreset } from './app.theme';
import { AuthenticationService } from './core/providers/services/authentication.service';
import { inject } from '@angular/core';
import { MessageService, ConfirmationService } from 'primeng/api';

registerLocaleData(fr);

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimationsAsync(),
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes, withViewTransitions(appViewTransitionOptions), withInMemoryScrolling({
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled'
    })),
    provideHttpClient(
      withFetch(),
      withInterceptors([httpInterceptor]),
      withXsrfConfiguration({
        cookieName: 'XSRF-TOKEN',
        headerName: 'X-XSRF-TOKEN'
      })
    ),
    MessageService,
    ConfirmationService,
    providePrimeNG(
      {
        theme: {
          preset: ootdPreset,
          options: {
            cssLayer: {
              name: 'primeng',
              order: 'primeng, ootd-styles'
            }
          }
        },
      },
    ),
    provideAppInitializer(() => {
      const authService = inject(AuthenticationService);
      return authService.initialize();
    })
  ]
};
